import Model  from '@/util/models';

export default class Provinsi extends Model { 
    backend = '/master/quetionnaire/';   
    
    create(formData){
        return this.api.post(this.backend+'create', formData, null, {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        });
    }

    update(formData, params={}){
        return this.api.post(this.backend+'update', formData, params, {
            'accept': 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
        });
    }
}

